export class ConventionFilter {

  client: string;
  clientType;
  clientCode: string;
  placeId: number;

}
